export const SHOW_MODAL = 'SHOW_MODAL'
export const SET_MODAL_CONTENT = 'SET_MODAL_CONTENT'
